import React, { useState } from 'react';
import { BookOpen } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from '../i18n';
import { getPracticeNoteMetadata } from '../utils/noteTheme';
import PracticeSettings from './PracticeSettings';
import PracticeSettingsService from '../services/PracticeSettingsService';
import QuickPracticeAction from './QuickPracticeAction';
import './NoteDetail.css';

export default function StartNotePracticeAction({ noteId, note, flashcards = [], disabled = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const practiceNote = getPracticeNoteMetadata(note);

  const handleStart = (settings) => {
    navigate('/practice', {
      state: {
        testContext: {
          type: 'note',
          noteId,
          note: practiceNote,
          flashcards,
          settings,
          returnTo: location.pathname,
          returnState: location.state,
        },
      },
    });
  };

  const handleStartPlayer = (settings) => {
    navigate('/practice-player', {
      state: {
        playerContext: {
          flashcards,
          mode: settings.playerMode,
          settings,
          noteId,
          note: practiceNote,
          includeAllCards: true,
          returnTo: location.pathname,
          returnState: location.state,
        },
      },
    });
  };

  const completed = flashcards.length > 0 && flashcards.every(PracticeSettingsService.isGraduated);
  if (completed) return <QuickPracticeAction source={{ type: 'note', id: noteId }} note={note} disabled={disabled}
    renderTrigger={(open, busy) => <button type="button" className="note-detail-button note-detail-button-primary"
      disabled={disabled || busy} onClick={open}><BookOpen size={18} aria-hidden="true" />{t('notesUnified.startPractice')}</button>} />;

  return (
    <>
      <button
        type="button"
        className="note-detail-button note-detail-button-primary"
        disabled={disabled}
        onClick={() => setSettingsOpen(true)}
      >
        <BookOpen size={18} aria-hidden="true" />
        {t('notesUnified.startPractice')}
      </button>
      <PracticeSettings
        isOpen={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        onStart={handleStart}
        onStartPlayer={handleStartPlayer}
      />
    </>
  );
}
